<ng-container *ngIf="view$ | async as view">
  <app-chat-thread
    *ngIf="threadTarget(view) as target; else logs"
    class="chat-drawer__view"
    [target]="target"
    [showBack]="view.mode === 'thread' && !!view.fromLogs"
    (back)="showLogs()"
    (closed)="close()"
  ></app-chat-thread>

  <ng-template #logs>
    <app-chat-logs class="chat-drawer__view" (rowSelected)="openRow($event)" (closed)="close()"></app-chat-logs>
  </ng-template>
</ng-container>
